import { createGlobalStyle } from 'styled-components'
import media from './MediaQueries'

export const GlobalStyle = createGlobalStyle`
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    user-select: none;
}

html {

    ${media.large`
        font-size: 56.25%;
   `}   

    ${media.medium`
        font-size: 50%;
   `}  

    font-size: 62.5%;
}

body {
    background-color: ${props => props.mainColor} !important;
    font-family: gill-sans-nova, sans-serif !important;
    font-weight: 300;
    font-style: normal;
}`